export interface AiChatPreferences {
  areActionTilesHidden: boolean;
}

export const DEFAULT_PREFERENCES: AiChatPreferences = {
  areActionTilesHidden: true,
};

export const getAiChatPreferences = async (): Promise<AiChatPreferences> => {
  try {
    const raw = (await window.PMW.readLocal('ai/getAiChatPreferences')) as Partial<AiChatPreferences> | null;
    return {
      areActionTilesHidden: raw?.areActionTilesHidden ?? DEFAULT_PREFERENCES.areActionTilesHidden,
    };
  } catch (error) {
    console.error(error);
    return DEFAULT_PREFERENCES;
  }
};

export const hideActionTiles = async (): Promise<void> => {
  await window.PMW.writeLocal('ai/hideActionTiles', {});
};

export const markAiChatTemplatesTileAsSeen = async (): Promise<void> => {
  await window.PMW.writeLocal('ai/markAiChatTemplatesTileAsSeen', {});
};

export const hasUserSeenAiChatTemplatesTile = async (): Promise<boolean> => {
  try {
    return Boolean(await window.PMW.readLocal('ai/hasUserSeenAiChatTemplatesTile'));
  } catch (error) {
    console.error(error);
    return false;
  }
};
